// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2579":"c9f60f53b4ba0ef8","8234":"af8b14791d850eb3","9441":"01e303d912fdd7db"}[chunkId] + ".css";
};